module.exports = __webpack_public_path__ + "static/netflix-ccxp-2-c8caf1372168b8c0d49e85a5817b0085.jpg";